// @flow
import { PRODUCTS_FILTERS } from 'Client/cms/toolkit/constants';
import { ProductsFiltersLine } from 'Components/lines/products-filters-line/ProductsFiltersLine.jsx';
import { productsFiltersResolver } from './productsFilters.resolver';

export const productsFiltersDescriptor = {
  name: PRODUCTS_FILTERS,
  component: ProductsFiltersLine,
  resolve: productsFiltersResolver.resolve,
};
